<template>
  <div id="container">
    <transition name="fade">
      <div v-if="isShipVisible" id="ship"></div>
    </transition>
  </div>
</template>

<script>
import * as THREE from "three";
export default {
  name: "Waves",
  data: function() {
    return {
      camera: null,
      lottie: require("lottie-web")
    };
  },
  computed: {
    isShipVisible: function() {
      return this.$store.state.ship;
    }
  },
  mounted: function() {
    if (this.isShipVisible) {
      var element = document.getElementById("ship");
      this.lottie.loadAnimation({
        container: element, // the dom element that will contain the animation
        renderer: "svg",
        loop: true,
        autoplay: true,
        path: "nave.json" // the path to the animation json
      });
    }
    var container = document.getElementById("container");

    var vertexHeight = 15000,
      planeDefinition = 100,
      planeSize = 1245000,
      background = "#0081c5",
      meshColor = "#00cdf5";

    this.camera = new THREE.PerspectiveCamera(
      55,
      window.innerWidth / window.innerHeight,
      1,
      400000
    );

    var camera = this.camera;

    camera.position.z = 30000;
    camera.position.y = 70000;

    var scene = new THREE.Scene();
    // aumenta diminuisce orizzonte
    scene.fog = new THREE.Fog(background, 1, 500000);

    var planeGeo = new THREE.PlaneGeometry(
      planeSize,
      planeSize,
      planeDefinition,
      planeDefinition
    );
    var plane = new THREE.Mesh(
      planeGeo,
      new THREE.MeshBasicMaterial({
        color: meshColor,
        wireframe: true
      })
    );
    plane.rotation.x -= Math.PI * 0.5;

    scene.add(plane);

    var renderer = new THREE.WebGLRenderer({ alpha: true });
    //renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.setSize(container.offsetWidth, container.offsetHeight);
    renderer.setClearColor(0x000000, 0);

    container.appendChild(renderer.domElement);

    updatePlane();

    function updatePlane() {
      for (var i = 0; i < planeGeo.vertices.length; i++) {
        planeGeo.vertices[i].z += Math.random() * vertexHeight - vertexHeight;
        planeGeo.vertices[i]._myZ = planeGeo.vertices[i].z;
      }
    }

    render();

    var count = 0;

    function render() {
      requestAnimationFrame(render);
      // camera.position.z -= 150;
      var x = camera.position.x;
      var z = camera.position.z;
      camera.position.x = x * Math.cos(0.001) + z * Math.sin(0.001) - 10;
      camera.position.z = z * Math.cos(0.001) - x * Math.sin(0.001) - 10;
      // abbasso posizione mare
      camera.lookAt(new THREE.Vector3(0, 70000, 30000));

      for (var i = 0; i < planeGeo.vertices.length; i++) {
        //var z = +planeGeo.vertices[i].z;
        // qui configuro l'altezza delle onde 0.6
        planeGeo.vertices[i].z =
          Math.sin(i + count * 0.00002) *
          (planeGeo.vertices[i]._myZ - planeGeo.vertices[i]._myZ * 0.6);
        plane.geometry.verticesNeedUpdate = true;

        count += 0.1;
      }

      renderer.render(scene, camera);
    }

    window.addEventListener("resize", onWindowResize, false);

    function onWindowResize() {
      //changes the size of the canavs and updates it
      camera.aspect = container.offsetWidth / container.offsetHeight;
      camera.updateProjectionMatrix();
      //renderer.setSize(window.innerWidth, window.innerHeight);
      renderer.setSize(container.offsetWidth, container.offsetHeight);
    }
  },
  updated: function() {
    var element = document.getElementById("ship");
    if (element.innerHTML.length === 0) {
      this.lottie.loadAnimation({
        container: element, // the dom element that will contain the animation
        renderer: "svg",
        loop: true,
        autoplay: true,
        path: "nave.json" // the path to the animation json
      });
    }
  }
};
</script>

<style scoped></style>
